<template>
    <Head title="Entrar" />

    <div class="bg-gray-200 h-screen relative flex overflow-auto">
        <div class="absolute bg-primary-500 h-1/2 w-full top-0"></div>

        <div
            class="flex flex-col p-6 z-10 space-y-7 w-full items-center justify-center"
        >
            <!-- logo + title -->
            <XyzTransition v-show="isImageLoaded" appear xyz="fade">
                <Link :href="route('dashboard')" class="flex space-x-3">
                    <img
                        src="@assets/images/shared/logo-shipro-light.svg"
                        class="scale-125"
                        alt="logo"
                    />
                    <span class="text-3xl text-white font-bold">Shipro</span>
                </Link>
            </XyzTransition>

            <!-- sign in card -->
            <XyzTransition v-show="isImageLoaded" appear xyz="fade">
                <div
                    class="flex shadow-md min-w-full sm:min-w-[500px] lg:min-w-min"
                >
                    <div
                        class="flex flex-col justify-center w-full bg-white p-6 sm:p-8 lg:p-16 lg:w-[450px] rounded-lg lg:rounded-none lg:rounded-l-lg"
                    >
                        <span
                            class="text-xl lg:text-2xl font-bold text-gray-900"
                            >Accede a la plataforma</span
                        >
                        <form
                            @submit.prevent="submit"
                            class="flex flex-col mt-6 space-y-3"
                        >
                            <div class="flex flex-col">
                                <label
                                    for="username"
                                    class="block mb-2 text-sm font-medium text-gray-900"
                                    >Usuario</label
                                >
                                <input
                                    type="text"
                                    id="username"
                                    v-model="form.username"
                                    :class="[
                                        'bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 hover:border-primary-500 block w-full p-2.5',
                                        errors?.email
                                            ? 'border-red-400'
                                            : 'border-gray-300',
                                    ]"
                                    placeholder="Usuario123"
                                    required
                                    autofocus
                                    @focus="clearErrors"
                                />
                                <div class="h-5 w-auto">
                                    <span
                                        v-if="hasErrors"
                                        class="text-[10px] text-red-500"
                                        >{{ errors.username }}</span
                                    >
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <label
                                    for="password"
                                    class="block mb-2 text-sm font-medium text-gray-900"
                                    >Contraseña</label
                                >
                                <input
                                    type="password"
                                    id="password"
                                    v-model="form.password"
                                    placeholder="Contraseña"
                                    :class="[
                                        'bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 hover:border-primary-500 block w-full p-2.5',
                                        errors?.password
                                            ? 'border-red-400'
                                            : 'border-gray-300',
                                    ]"
                                    required
                                    autocomplete="current-password"
                                    @focus="clearErrors"
                                />
                                <div class="h-5 w-auto">
                                    <span
                                        v-if="hasErrors"
                                        class="text-[10px] text-red-500"
                                        >{{ errors.password }}</span
                                    >
                                </div>
                            </div>
                            <div class="flex items-start mb-6">
                                <div class="flex items-center h-5">
                                    <input
                                        id="remember"
                                        aria-describedby="remember"
                                        v-model="form.remember"
                                        type="checkbox"
                                        class="w-4 h-4 bg-gray-50 rounded border border-gray-300 focus:ring-3 focus:ring-primary-500 hover:border-primary-500"
                                    />
                                </div>
                                <div class="ml-3 text-sm">
                                    <label
                                        for="remember"
                                        class="font-medium text-gray-900"
                                        >Recuerdame</label
                                    >
                                </div>
                            </div>
                            <button
                                type="submit"
                                class="text-white bg-primary-500 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                                :class="{ 'opacity-50': form.processing }"
                                :disabled="form.processing"
                            >
                                Entrar
                            </button>
                            <Link
                                type="button"
                                class="text-sm text-primary-700 hover:cursor-pointer hover:underline self-center"
                                :href="route('password.request')"
                                >Olvide mi contraseña</Link
                            >
                        </form>
                    </div>
                    <div class="hidden lg:block lg:w-1/2 max-w-screen-sm">
                        <img
                            src="@assets/images/login/truck-with-boxes.png"
                            class="object-none object-center max-h-[500px] w-full rounded-r-lg brightness-75"
                            alt="banner"
                            @load="imageLoaded"
                        />
                    </div>
                </div>
            </XyzTransition>
        </div>

        <!-- footer -->
        <div class="absolute bottom-1 inset-x-0 text-center">
            <span class="text-[12px] text-gray-600">Copyright© 2018-2022</span>
        </div>
    </div>
</template>

<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Spinner from "../../shared/Spinner.vue";

export default {
    components: {
        Head,
        Link,
        Spinner,
    },
    props: {
        canResetPassword: Boolean,
        status: String,
    },
    data() {
        return {
            isImageLoaded: false,
            form: this.$inertia.form({
                username: "",
                password: "",
                remember: false,
            }),
        };
    },
    computed: {
        errors() {
            return this.$page.props.errors;
        },

        hasErrors() {
            return Object.keys(this.errors).length > 0;
        },
    },
    methods: {
        imageLoaded() {
            this.isImageLoaded = true;
        },
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    remember: this.form.remember ? "on" : "",
                }))
                .post(this.route("login"), {
                    onFinish: () => this.form.reset("password"),
                });
        },
        clearErrors() {
            if (this.$page.props.errors) {
                this.$page.props.errors = {};
            }
        },
    },
};
</script>
